import Component from '../colorz/Component';
import device   from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

/*
* slider - level 2
* voir template strate-expertise-declinaisons.php
*/

module.exports = class RealSlider extends Component{
    onInit( el, args ) {
        this.onClick        = this.onClick.bind( this );
        this.onNext         = this.onNext.bind(this);
        this.onPrev         = this.onPrev.bind(this);
        this.onSlideChange  = this.onSlideChange.bind(this);

        this.el             = el;
        this.tabParent      = this.el.parentNode.parentElement.parentElement.parentElement; // = this.el.closest('.js-slider-tab') but closest method not supported in IE11 need a polyfill
        this.tabContainer   = this.tabParent.querySelector('.js-tab' );
        this.tabContent     = this.tabParent.querySelectorAll('.js-tab-content');
        this.tabList        = this.tabParent.querySelectorAll('.js-single-tab');
        this.active         = 0;

        if (window.matchMedia("(min-width:1080px)").matches) {
            this.nextBtn        = this.el.querySelector('.next');
            this.prevBtn        = this.el.querySelector('.prev');
        }
    }

    onReady() {
        // init slider
        this.initSlider();

        this.setActive();    

        for (var i = 0; i < this.tabList.length; i++){
            this.tabList[i].addEventListener(device.pointerdown, this.onClick);
        }

        if (window.matchMedia("(min-width:1080px)").matches) {
            // events on nav buttons
            this.nextBtn.addEventListener( device.pointerdown, this.onNext );
            this.prevBtn.addEventListener( device.pointerdown, this.onPrev );
        } else {
            window.addEventListener( device.pointerdown, this.onNext );
            window.addEventListener( device.pointerdown, this.onPrev );
        }

        // disable horizontal scroll
        document.body.classList.add('js-has-flickity');
    }

    onNext() {
        this.slider.next();
        this.onSlideChange();
    }

    onPrev() {
        this.slider.previous();
        this.onSlideChange();
    }

    onSlideChange() {

        if ( this.slider.selectedIndex == this.slider.slides.length -1 ) {
            this.el.classList.add('is-last');
        } else {
            this.el.classList.remove('is-last');
        }
    }

    onClick(e) {

        for (var i = 0; i < this.tabList.length; i++) {
            this.tabList[i].classList.remove('active');
            if ( !e.currentTarget.classList.contains('active') ) {
                e.currentTarget.classList.add('active');
            }
        }
        this.unsetActive();

        if (this.tabContainer.contains(e.target)){
            this.active = e.target.dataset.id;
        }

        this.setActive();
    }

    setActive(){
        for (var i = 0; i < this.tabContent.length; i ++){
            if (this.tabContent[i].dataset.id == this.active) {
                this.tabContent[i].classList.add('active');
                this.slider.resize();
            }
        }
    }

    unsetActive(){
        for (var i = 0; i < this.tabContent.length; i ++){
            this.tabContent[i].classList.remove('active');
        }
    }

    initSlider(){
        var options = {
            cellSelector: '.js-slide',
            pageDots: false,
            cellAlign : 'center',
            prevNextButtons: false,
            wrapAround: true,
            imagesLoaded: true
        };

        if ( window.matchMedia('screen and (max-width: 1080px)').matches ) {
            options.draggable = true;
        } else {
            options.draggable = false;
        }

        // init slider
        this.slider = new Flickity(this.el, options);

    }

};
